// src/cert/lead-auditor.js
import React from 'react';
import ApplyForm from '../components/ApplyForm';
import './CertPage.css';

const LeadAuditor = () => {
  return (
    <div className="cert-page">
      <div className="cert-header">
        <h1>Lead Auditor प्रशिक्षण</h1>
        <p>प्रमाणन व्यवस्थापन प्रणाली ऑडिटर नेतृत्व प्रशिक्षण</p>
      </div>

      <div className="cert-content">
        <section>
          <h2>Lead Auditor प्रशिक्षण म्हणजे काय?</h2>
          <p>
            Lead Auditor प्रशिक्षण हे <strong>ISO 9001, 14001, 45001, 27001 सारख्या मानकांसाठी</strong> 
            <strong>आंतरिक आणि बाह्य ऑडिट्स</strong> नेतृत्व करण्यासाठी व्यावसायिक कौशल्ये शिकवते. 
            हे <strong>CQI/IRCA, Exemplar Global</strong> प्रमाणित कोर्स असते जे ऑडिट प्लॅनिंग, अंमलबजावणी, 
            अहवाल तयार करणे आणि सुधारणांसाठी मार्गदर्शन देते.
          </p>
        </section>

        <section>
          <h2>प्रमुख फायदे</h2>
          <ul>
            <li>ऑडिट टीम लीड करण्याचे व्यावहारिक कौशल्ये</li>
            <li>CQI/IRCA प्रमाणन आणि रजिस्टरवर नाव</li>
            <li>प्रमाणन ऑडिटर म्हणून करिअर वाढ</li>
            <section className="apply-section">
              <h2>Lead Auditor प्रशिक्षणासाठी अर्ज करा</h2>
              <ApplyForm certification="Lead Auditor Training" />
            </section>
          </ul>
        </section>
      </div>
    </div>
  );
};

export default LeadAuditor;